module.exports = __webpack_public_path__ + "static/zapier-switchboard-7e0cf935d0543196afb2188c9b87eb26.svg";